import React from "react";
import {__} from "@wordpress/i18n";
import zodiacResultContentArray from "./chinese-zodiac-result-content.js";
import {CalendarChinese} from "date-chinese";
import ReactDOM from "react-dom";

/**
 * we get the chinese new year date
 * this date changes every year
 *
 * @param date year
 *
 * @return date
 * */
function getChineseNewYearDate(year)
{
	let cinoCalendar = new CalendarChinese();
	let newYearDate = cinoCalendar.newYear(year);
	cinoCalendar.fromJDE(newYearDate);

	// convert to Gregorian Date (Chinese Standard Time)
	let gregorianDate = cinoCalendar.toGregorian();
	return new Date(gregorianDate.year, gregorianDate.month - 1, gregorianDate.day, 8, 0, 0, 0);
}

/**
 * React component that computes and renders the Chinese zodiac result.
 * Reads the user's birth date from the DOM (select inputs populated by ChineseZodiacCalculator).
 * @returns {JSX.Element} The zodiac result card with traits, image, and description.
 */
function GetChineseSign() {
	// Read the selected birth date from the DOM inputs
	const birthYear = document.getElementById('birthYear').value;
	const birthMonth = document.getElementById('birthMonth').value;
	const birthDay = document.getElementById('birthDay').value;

	// Build a normalized date at midnight to compare with Chinese New Year
	const dateOfBirth = new Date(birthYear, birthMonth - 1, birthDay).setHours(0, 0, 0, 0);

	// Get the Chinese New Year date for the birth year (it changes every year)
	const chineseNewYearDate = getChineseNewYearDate(birthYear).setHours(0, 0, 0, 0);

	// The Chinese zodiac cycle repeats every 12 years; year % 12 gives the base index
	let zodiacIndex = birthYear % 12;

	// If the birthday falls before the Chinese New Year of that year,
	// the person still belongs to the previous year's zodiac sign
	if(dateOfBirth < chineseNewYearDate) {
		// Wrap around: index 0 becomes 11 (previous sign in the 12-cycle)
		if(zodiacIndex === 0) {
			zodiacIndex = 11;
		}
		else {
			zodiacIndex = zodiacIndex - 1;
		}
	}
	else {
		// Birthday is after Chinese New Year: keep the computed index
		zodiacIndex = zodiacIndex;
	}

	// Retrieve the zodiac data object for the computed index
	const zodiacResult = zodiacResultContentArray[zodiacIndex];

	// Check whether the Chinese character should be displayed (driven by block setting)
	const hideChineseCharacter = document.getElementById('hideChineseCharacter').value;

	return (
		<>
			<div className={"chinese-zodiac-result-container " + zodiacResult.yin_yang.toLowerCase()}>
				<p className={"chinese-zodiac-title"}>
					{zodiacResult.zodiac}
					{hideChineseCharacter === 'show' &&
						<span className={"chinese-character"}> {zodiacResult.chinese}</span>
					}
				</p>
				<div className={"chinese-zodiac-table"}>
					<div className={"chinese-zodiac-informations"}>
						<p><span>{__("Élément :", "superprof-gutenberg-blocks")} </span>{zodiacResult.element}</p>
						<p><span>{__("Yin Yang :", "superprof-gutenberg-blocks")} </span>{zodiacResult.yin_yang}</p>
						<p><span>{__("Mois lunaire :", "superprof-gutenberg-blocks")} </span>{zodiacResult.lunar_month}</p>
						<p><span>{__("Chiffres :", "superprof-gutenberg-blocks")} </span>{zodiacResult.numbers}</p>
						<p><span>{__("Fleurs :", "superprof-gutenberg-blocks")} </span>{zodiacResult.flower}</p>
						<p><span>{__("Couleurs :", "superprof-gutenberg-blocks")} </span>{zodiacResult.color}</p>
					</div>
					<div className={"chinese-zodiac-image"}>
						<div className={"background-image"} style={{ backgroundImage: 'url(' + require('../images/' + zodiacResult.img + '.png') + ')' }} role={"img"} aria-label={zodiacResult.zodiac}></div>
					</div>
				</div>
				<div className={"chinese-zodiac-description"}>
					{zodiacResult.description}
				</div>
			</div>
		</>
	)
}

export default function renderChineseSign()
{
	// if the DOM is ready and the element exists, we render the form in said element
	const chineseZodiacResult = document.getElementById("chinese-zodiac-result");
	if (chineseZodiacResult)
	{
		ReactDOM.render(<GetChineseSign/>, chineseZodiacResult)
	}
}
